<template>
  <main class="group_user-management-page" aria-label="Group User Management">
    <v-container fluid class="group_user-management-container">
      <v-card class="main-content-card" elevation="0">
        <v-card-text>
          
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('userGroupManagement') }}</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <div class="custom-search-input-wrapper">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="field-search-rowtable-dataIntegration" type="text" :placeholder="$t('userGroupName')"
                    :aria-label="$t('userGroupName')"
                    class="custom-search-input" v-model="searchDataIntegrationName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchDataIntegrationName ? '' : 'color: transparent !important;'"
                    @click="clearSearch()">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn id="add-groupusermanagement" color="primary" class="control-btn create-btn mr-0" variant="elevated"
                size="large" rounded="xl" @click="Adddialog = true">
                <img src="@/assets/Icons/new_round_plus.svg" alt="">
                <span class="btn-text">{{ $t("add") }}</span>
                <v-tooltip activator="parent" location="top">
                  {{ $t('addNewUserGroup') }}
                </v-tooltip>
              </v-btn>

            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table-server :items="dataTable" :items-per-page="options.itemsPerPage" :items-length="searchTotalTable"
          v-model:options="options" :headers="headers" :loading="loadingTable" class="rounded-xl user-group-table"
          :hover="true" fixed-header aria-label="Users Group table">

          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="text-center pa-8">
              <v-icon size="64" color="grey-lighten-2">mdi-database-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">{{ $t('noDataAvailable') }}</div>
              <div class="text-body-2 text-grey">{{ $t('tryDifferentSearch') }}</div>
            </div>
          </template>

          <!-- Group Name Column -->
          <template v-slot:item.groupName="{ item }">
            <div class="group-name-cell">
              <div class="cell-content">
                <div class="text-content">
                  <div class="primary-text">{{ item.groupName }}</div>
                  <div class="secondary-text" v-if="item.groupID">
                    ID: {{ item.groupID }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- Model Group Column -->
          <template v-slot:item.groupModelName="{ item }">
            <div class="model-group-cell">
              <v-chip v-if="item.groupModelName && item.groupModelName !== '-'" size="default" variant="outlined"
                class="model-group-chip">
                <v-img :src="images.modelGpImg" alt="Model Group Icon" class="template-icon" />
                <span class="model-group-chip__label">{{ item.groupModelName }}</span>
              </v-chip>
              <v-chip v-else size="default" variant="tonal" color="#646464" class="no-data-chip">
                {{ $t('noGroup') }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.modelDisplayName="slotProps">
            <td style="text-align: start">
              <div v-if="slotProps.item.modelDisplayNameTable && slotProps.item.modelDisplayNameTable !== '-'"
                class="model-display-cell">
                <div class="model-chip-list">
                  <template v-for="(model, index) in getModelDisplayList(slotProps.item.modelDisplayNameTable)"
                    :key="`model-display-${slotProps.item.id}-${index}`">
                    <v-chip v-if="index < maxVisibleModelChips" size="small" variant="outlined"
                      class="model-display-chip">
                      {{ model.name }}
                    </v-chip>
                  </template>
                </div>
                <div class="model-display-actions">
                  <v-btn id="search-groupusermanagement" variant="tonal" color="grey"
                    class="detail-btn model-display-more-btn" density="comfortable" @click="Detail(slotProps)">
                    <v-icon
                      v-if="getModelDisplayList(slotProps.item.modelDisplayNameTable).length <= maxVisibleModelChips"
                      color="#FFFFFF">mdi-magnify</v-icon>
                    <span v-else class="model-display-more-label">
                      +{{ getModelDisplayList(slotProps.item.modelDisplayNameTable).length - maxVisibleModelChips }}
                    </span>
                    <v-tooltip activator="parent" location="top">
                      {{ $t('viewDetails') }}
                    </v-tooltip>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>

          <!-- Status Sync Column -->
          <template v-slot:item.statusSyncEntraID="{ item }">
            <div class="status-cell">
              <v-chip :color="item.statusSyncEntraID ? '#2ABF56' : '#C30000'" variant="tonal" size="default"
                class="status-chip">
                <v-icon :icon="item.statusSyncEntraID ? 'mdi-check-circle' : 'mdi-close-circle'" size="16"
                  class="mr-1"></v-icon>
                {{ item.statusSyncEntraID ? $t('synced') : $t('notSynced') }}
              </v-chip>
            </div>
          </template>

          <!-- Actions Column (ยังคงเหมือนเดิม) -->
          <template v-slot:item.actions="{ item }">
            <div class="action-group" style="justify-content: center;">
              <!-- Edit -->
              <v-btn id="edit-groupusermanagement" variant="text" density="comfortable" @click="Edit(item)"
                class="action-btn edit-btn" icon>
                <v-img :src="images.editImg" width="20" height="20" />
                <v-tooltip activator="parent" location="top">
                  {{ $t('edit') }}
                </v-tooltip>
              </v-btn>

              <!-- Delete -->
              <v-btn id="delete-groupusermanagement" variant="text" density="comfortable" @click="Delete(item)"
                class="action-btn delete-btn" icon>
                <v-img :src="images.deleteImg" width="20" height="20" />
                <v-tooltip activator="parent" location="top">
                  {{ $t('delete') }}
                </v-tooltip>
              </v-btn>
            </div>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4"
              style="width: 100%; margin-top: 24px;"
            >
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: $t('all'), value: -1 },
                ]"
                class="pt-0"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <!-- AddUserDialog -->
    <v-dialog v-model="Adddialog" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Dialog Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h3 class="dialog-title">{{ $t("addUserGroup") }}</h3>
              <p class="dialog-subtitle">{{ $t('createNewUserGroup') }}</p>
            </div>
          </div>
        </div>

        <!-- Dialog Content -->
        <v-card-text class="dialog-content">
          <div class="dialog-content-intro">
            <!-- Basic Information Section -->
            <div class="border-section-wrapper mb-7">
              <div class="basic-info-container">
                <img :src="images.basicInfoIcon" alt="Basic Info" class="basic-info-icon" />
                <span class="section-title">{{ $t('basicInformation') }}</span>
              </div>

              <v-row class="section-content">
                <!-- Group Name -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <div class="input-label">
                      {{ $t('groupname') }}<span class="required-asterisk">*</span>
                    </div>
                    <v-text-field ref="groupName" id="groupname-add-groupusermanagement" :label="$t('groupname')"
                      v-model="add.groupName" required :rules="[rules.required]" variant="outlined"
                      density="comfortable" class="modern-field mt-2" hide-details="auto">
                    </v-text-field>
                  </div>
                </v-col>

                <!-- Group ID -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <div class="input-label">
                      {{ $t('groupId') }}<span class="required-asterisk">*</span>
                    </div>
                    <v-text-field ref="groupID" id="groupid-add-groupusermanagement" :label="$t('groupId')"
                      v-model="add.groupID" required variant="outlined" density="comfortable" class="modern-field mt-2"
                      hide-details="auto">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Model Configuration Section -->
            <div class="border-section-wrapper">
              <div class="basic-info-container">
                <img :src="images.modelConfigIcon" alt="Basic Info" class="basic-info-icon" />
                <h4 class="section-title">{{ $t('modelConfiguration') }}</h4>
              </div>

              <v-row class="section-content">
                <!-- Model Grouping -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <div class="input-label">
                      {{ $t('selectModelGrouping') }}
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip-content">
                          <div>{{ $t("_InfoSelectGroupModel") }}</div>
                        </div>
                      </v-tooltip>
                    </div>
                    <v-autocomplete id="modelgrouping-add-groupusermanagement" :label="$t('modelGrouping')"
                      :items="listDDGroupModel" item-title="name" item-value="id" clearable variant="outlined"
                      density="comfortable" v-model="add.groupModelID" class="modern-field mt-2" hide-details="auto"
                      :placeholder="$t('selectModelGrouping')">
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'modelgrouping-addgroupuser-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>

                <!-- Model Selection -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <div class="input-label">
                      {{ $t('selectModel') }}
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">{{ $t('_selectAiModelsAccess') }}</div>
                      </v-tooltip>
                    </div>
                    <v-autocomplete id="model-add-groupusermanagement" :label="$t('model')"
                      :items="filterListDDModel" item-title="name" item-value="modelDisplayID" multiple
                      variant="outlined" density="comfortable" clearable v-model="add.modelDisplay"
                      class="modern-field mt-2 role-autocomplete model-autocomplete" hide-details="auto"
                      :placeholder="$t('selectModels')"
                      :menu-props="{ closeOnContentClick: false, closeOnOutsideClick: false }"
                      @update:modelValue="handleModelSelection">
                      <template #prepend-item>
                        <v-list-item class="model-option-item model-all-option"
                          :class="{ 'model-all-option--active': isAllModelsSelected(add.modelDisplay), 'model-all-option--disabled': !filterListDDModel.length }"
                          density="compact" @mousedown.prevent @click.stop="toggleAllModels">
                          <template #prepend>
                            <v-checkbox-btn class="model-option-checkbox"
                              :model-value="isAllModelsSelected(add.modelDisplay)" color="#C30000" :ripple="false"
                              :disabled="!filterListDDModel.length" @click.stop="toggleAllModels"></v-checkbox-btn>
                          </template>
                          <template #title>
                            <div class="model-all-title">
                              <span class="model-all-option__label">{{ $t('allModel') }}</span>
                              <v-tooltip location="top">
                                <template #activator="{ props }">
                                  <v-icon v-bind="props" size="18" class="model-info-icon">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>{{ $t('_allModelsIncluded') }}</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-list-item>
                        <v-divider class="model-all-divider"></v-divider>
                      </template>

                      <template #item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'model-addgroupuser-option-' + index"
                          class="model-option-item"
                          :class="{ 'model-option-item--selected': isModelSelected(item.raw.modelDisplayID) }"
                          @click="props.onClick" @mousedown.prevent>
                          <template #prepend>
                            <v-checkbox-btn class="model-option-checkbox"
                              :model-value="isModelSelected(item.raw.modelDisplayID)" color="#C30000" :ripple="false"
                              @click.stop="props.onClick"></v-checkbox-btn>
                          </template>
                          <template #title>
                            <span class="model-option-title">{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>

                      <template #selection="{ item, index }">
                        <span v-if="shouldCollapseModelChips(add.modelDisplay) && index === 0"
                          class="model-all-selected-label">
                          {{ $t('allModel') }}
                          <v-tooltip location="top">
                            <template #activator="{ props }">
                              <v-icon v-bind="props" size="18" class="model-info-icon">
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>{{ $t('_allModelsIncluded') }}</span>
                          </v-tooltip>
                        </span>
                        <template v-else-if="!shouldCollapseModelChips(add.modelDisplay)">
                          <v-chip v-if="index < modelChipDisplayLimit" class="model-chip" size="small" closable
                            @click:close="onModelChipClose(item.value)">
                            <template #close>x</template>
                            {{ item.title }}
                          </v-chip>
                          <v-chip v-else-if="index === modelChipDisplayLimit && hasHiddenModelChips(add.modelDisplay)"
                            class="model-chip more-chip" size="small">
                            {{ getHiddenModelChipLabel(add.modelDisplay) }}
                          </v-chip>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- Model Selection Info -->
              <v-row v-if="add.modelDisplay && add.modelDisplay.length > 0">
                <v-col cols="12">
                  <div class="selection-info">
                    <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span class="info-text">
                      {{ $t('modelsSelected', { count: add.modelDisplay.length }) }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content-new">
            <div class="actions-left">
              <v-chip v-if="add.groupName" size="small" variant="tonal" color="success" class="status-chip">
                <v-icon size="14" class="mr-1">mdi-check</v-icon>
                {{ $t('readyToSave') }}
              </v-chip>
            </div>

            <div class="actions-right">
              <v-btn variant="outlined" color="grey" @click="Adddialog = false" class="dialog-action-btn cancel-btn">
                {{ $t("cancel") }}
              </v-btn>

              <v-btn id="save-add-groupusermanagement" variant="elevated" @click="Save"
                class="dialog-action-btn save-btn-add" :disabled="!add.groupName">
                <v-img :src="images.newSaveImg" alt="Add Group Dialog" class="image-icon-style"></v-img>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Detail Dialog -->
    <v-dialog v-model="Detaildialog" max-width="600px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Dialog Header -->
        <div class="dialog-header dialog-header-add">
          <div class="d-flex flex-column">
            <div class="header-text-content d-flex flex-row align-middle">
              <h3 class="dialog-title mb-0">{{ $t('viewDetails') }}</h3>
              <div class="actions-left">
                <v-chip v-if="TempModel.length > 0" size="small" variant="tonal" class="summary-chip ml-2">
                  {{ $t('modelsCount', { count: TempModel.length }) }}
                </v-chip>
              </div>
            </div>
            <p class="dialog-subtitle">{{ $t('modelDetailsAndInformation') }}</p>
          </div>
        </div>

        <!-- Dialog Content -->
        <v-card-text class="detail-content">
          <div class="models-container">
            <!-- Empty State -->
            <div v-if="TempModel.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-2">mdi-robot-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">{{ $t('noModelsFound') }}</div>
              <div class="text-body-2 text-grey">{{ $t('noModelDataToDisplay') }}</div>
            </div>

            <!-- Model List -->
            <div v-else class="model-list">
              <div v-for="(item, index) in TempModel" :key="item.id" class="model-item"
                :class="{ 'last-item': index === TempModel.length - 1 }">
                <div class="model-card">
                  <div class="model-content">
                    <div class="model-info">
                      <div class="model-icon-wrapper">
                        <v-img :src="images.modelGpRedImg" alt="Model Group Icon" class="template-dialog-icon" />
                      </div>
                      <div class="model-details">
                        <h4 class="model-name">{{ item.name }}</h4>
                      </div>
                    </div>

                    <div class="model-actions">
                      <v-btn variant="outlined" color="#C32E0E" size="small" class="view-btn" @click="View(item)">
                        <v-icon size="16" class="mr-1">mdi-eye-outline</v-icon>
                        {{ $t('view') }}
                      </v-btn>
                    </div>
                  </div>
                </div>

                <!-- Divider (except for last item) -->
                <v-divider v-if="index < TempModel.length - 1" class="model-divider"></v-divider>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="detail-actions">
          <div class="detail-actions-content">
            <div class="actions-right">
              <v-btn color="grey" @click="Detaildialog = false" class="dialog-action-btn close-action-btn">
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Pleas Wait -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="flagTemplate" max-width="800px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">{{ $t('templateUser') }}</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table-server :items="dataTemplate" :headers="headersTemplate" :loading-text="$t('loading')"
              hide-default-footer disable-sort>
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    <v-btn icon @click="linkDownload(item.CSV)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"> mdi-file</v-icon>
                        </template>
                        <span>{{ $t('_userCsvTooltip') }}</span>
                      </v-tooltip>
                    </v-btn>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="linkDownload(item.Excel)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-file-excel</v-icon>
                        </template>
                        <span>{{ $t('_userExcelTooltip') }}</span>
                      </v-tooltip>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="flagTemplate = false">{{
            $t("close")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </main>
</template>

<script>
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import editImg from '@/assets/images/editbutton.png';
import deleteImg from '@/assets/images/trashbutton.png';
import modelGroupBoxImg from '@/assets/Icons/box-model.svg';
import modelGroupRedBoxImg from '@/assets/Icons/box-model-red.svg';
import basicInfoIcon from "@/assets/Icons/basic_info.svg";
import modelConfigIcon from "@/assets/Icons/ai-duotone.svg";
import newSaveImg from "@/assets/Icons/white-save-floppy.svg";
import deleteIcon from "@/assets/images/trash-solid.svg";

export default {
  name: "GroupUserManagement",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data() {
    return {
      searchDataIntegrationName: null,
      mask: "##########",
      show1: false,
      filters: {
        username: [],
        email: [],
        employeeName: [],
        userType: [],
      },
      numberRules: [(v) => !!v || "Input is required!"],
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        min: (v) => v.length >= 10 || "Min 10 numbers",
      },
      Email: null,
      gg: null,
      UserType: null,
      dialog: false,
      add: {
        groupName: null,
        groupID: null,
        groupModelID: null,
        modelDisplay: null,
      },
      searchGroupModel: null,
      listDDGroupModel: [],
      searchModel: null,
      listDDModel: [],
      Adddialog: false,
      isSearch: false,
      username: "",
      email: "",
      totalTable: 0,
      itemsPerPage: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      today: null,
      userListDDL: [],
      userList: [],
      secretKey: "01234567890123456789012345678901",
      isFirst: true,
      searchTotalTable: 0,
      sortBy: [],
      sortDesc: [],
      DDQuickModel: [],
      accept:
        "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      fileImportUser: null,
      flagTemplate: false,
      dataTemplate: [
        {
          CSV: "CSV",
          Excel: "Excel",
        },
      ],
      flagSyncSSO: false,
      dataTable: [],
      TempModel: [],
      Detaildialog: false,
      loadingTable: false,
      //tempUserWarning: {},
      images: {
        editImg: editImg,
        deleteImg: deleteImg,
        modelGpImg: modelGroupBoxImg,
        modelGpRedImg: modelGroupRedBoxImg,
        basicInfoIcon: basicInfoIcon,
        modelConfigIcon: modelConfigIcon,
        newSaveImg: newSaveImg,
      },
      maxVisibleModelChips: 2,
      modelChipDisplayLimit: 5
    };
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchGroupModel(val) {
      this.GetGroupModel(val);
    },
    searchModel(val) {
      this.GetModel(val);
    },
    Adddialog: {
      handler(val) {
        if (!val) {
          this.CloseAdddialog();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.loadingTable = true;
    Promise.all([this.GetDate(), this.GetGroupModel(), this.GetModel()]).then(
      () => {
        this.dialog = false;
      }
    );
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          value: "number",
        },
        { title: this.$t("groupname"), sortable: true, value: "groupName" },
        {
          title: this.$t("modelGroup"),
          sortable: false,
          value: "groupModelName",
        },
        {
          title: this.$t("modelName"),
          sortable: false,
          value: "modelDisplayName",
        },
        {
          title: this.$t("statusSync"),
          align: "center",
          sortable: false,
          value: "statusSyncEntraID",
        },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          value: "actions",
          width: "150px",
        },
      ];
    },
    filterListDDModel() {
      const data = this.listDDModel.filter((item, index, array) => {
        return array.findIndex(obj => obj.modelDisplayID === item.modelDisplayID) === index;
      });
      return data
    },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
  },

  methods: {
    handleModelSelection(value) {
      const safeValues = Array.isArray(value) ? Array.from(new Set(value)) : [];
      const allIds = this.filterListDDModel.map((model) => model.modelDisplayID);

      if (safeValues.length >= allIds.length && allIds.length > 0) {
        this.add.modelDisplay = allIds.slice();
      } else {
        this.add.modelDisplay = safeValues;
      }
    },
    toggleAllModels() {
      const allIds = this.filterListDDModel.map((model) => model.modelDisplayID);
      if (!allIds.length) {
        return;
      }

      if (this.isAllModelsSelected(this.add.modelDisplay)) {
        this.add.modelDisplay = [];
      } else {
        this.add.modelDisplay = allIds.slice();
      }
    },
    isAllModelsSelected(selectedModels) {
      const allIds = this.filterListDDModel.map((model) => model.modelDisplayID);
      if (!Array.isArray(selectedModels) || selectedModels.length === 0) {
        return false;
      }

      if (selectedModels.length !== allIds.length) {
        return false;
      }

      return allIds.every((id) => selectedModels.includes(id));
    },
    isModelSelected(modelId) {
      return Array.isArray(this.add.modelDisplay) && this.add.modelDisplay.includes(modelId);
    },
    onModelChipClose(modelId) {
      if (!Array.isArray(this.add.modelDisplay)) {
        this.add.modelDisplay = [];
        return;
      }

      if (this.isAllModelsSelected(this.add.modelDisplay)) {
        this.add.modelDisplay = [];
      } else {
        this.add.modelDisplay = this.add.modelDisplay.filter((id) => id !== modelId);
      }
    },
    shouldCollapseModelChips(selectedModels) {
      return this.isAllModelsSelected(selectedModels);
    },
    hasHiddenModelChips(selectedModels) {
      if (!Array.isArray(selectedModels)) {
        return false;
      }
      return selectedModels.length > this.modelChipDisplayLimit && !this.shouldCollapseModelChips(selectedModels);
    },
    getHiddenModelChipLabel(selectedModels) {
      if (!this.hasHiddenModelChips(selectedModels)) {
        return '';
      }
      const remaining = selectedModels.length - this.modelChipDisplayLimit;
      return remaining > 0 ? this.$t('moreCountChip', { count: remaining }) : '';
    },
    getHeaderIcon(columnValue) {
      const iconMap = {
        'number': 'mdi-counter',
        'groupName': 'mdi-account-group',
        'groupModelName': 'mdi-layers',
        'modelDisplayName': 'mdi-robot',
        'statusSyncEntraID': 'mdi-sync',
        'actions': 'mdi-cog'
      }
      return iconMap[columnValue] || null
    },

    getSortIcon(columnValue) {
      if (!this.options.sortBy || this.options.sortBy[0]?.key !== columnValue) {
        return 'mdi-sort'
      }
      return this.options.sortBy[0]?.order === 'desc' ? 'mdi-sort-descending' : 'mdi-sort-ascending'
    },

    getDisplayRange() {
      const start = (this.options.page - 1) * this.options.itemsPerPage + 1
      const end = Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable)
      return `${start}-${end}`
    },
    View(item) {
      const routeData = this.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    Detail(temp) {
      let item = temp.item;
      this.TempModel = [];
      this.Detaildialog = true;
      const models = this.getModelDisplayList(item.modelDisplayName);
      this.TempModel = models.map((model) => ({
        name: model.name,
        id: model.id,
      }));
    },
    getModelDisplayList(source) {
      if (!source || source === "-" || typeof source !== "string") {
        return [];
      }
      return source
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0)
        .map((entry) => {
          const [namePart, ...rest] = entry.split(":");
          const name = (namePart || "").trim();
          const id = rest.length > 0 ? rest.join(":").trim() : null;
          return {
            name: name || entry,
            id: id && id.length ? id : null,
          };
        });
    },
    CloseAdddialog() {
      this.add = {
        groupName: null,
        groupID: null,
        groupModelID: null,
        modelDisplay: null,
      };
      this.Adddialog = false;
    },
    Save() {
      if (
        this.add.groupName != null &&
        this.add.groupName != "" &&
        ((this.add.groupModelID != null && this.add.groupModelID != "") ||
          (this.add.modelDisplay != null && this.add.modelDisplay != ""))
      ) {
        this.dialog = true;
        let temp = {
          groupName: this.add.groupName,
          groupObject_ID: this.add.groupID,
          groupModelID: this.add.groupModelID,
          modelDisplayID:
            this.add.modelDisplay == null
              ? null
              : JSON.stringify(this.add.modelDisplay),
        };
        this.$call.AddSecurityGroup(
          temp,
          (dataResponse) => {
            this.Adddialog = false;
            this.dialog = false;
            if (dataResponse.data == "Successfully") {
              this.Get();
              this.$swal.fire({
                title: this.$t('successBannerUserGroupCreated'),
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
            } else {
              this.$swal.fire({
                icon: "warning",
                title: dataResponse.data,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
          (err) => {
            this.dialog = false;

            this.$swal.fire({
              icon: "alert",
              title: err,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(err);
          }
        );
      } else if (
        this.add.groupName == null ||
        (this.add.groupName == "" &&
          (this.add.groupModelID == null || this.add.groupModelID == "") &&
          (this.add.modelDisplay == null ||
            this.add.modelDisplay == "" ||
            this.add.modelDisplay == [] ||
            this.add.modelDisplay == "null"))
      ) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t('_pleaseFillRequiredFields'),
          showConfirmButton: false,
          timer: 1500,
        });
      } else if (
        (this.add.groupModelID == null || this.add.groupModelID == "") &&
        (this.add.modelDisplay == null ||
          this.add.modelDisplay == "" ||
          this.add.modelDisplay == [] ||
          this.add.modelDisplay == "null")
      ) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t('pleaseSelectYourModel'),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    Delete(item) {
      let id = item.id;
      try {
        this.$swal
          .fire({
          //   title: this.$t("ConfirmDeletion"),
          //   text: this.$t("confirmDeletionTableName"),
          //   icon: "warning",
          //   showCancelButton: true,
          //   confirmButtonColor: "#3085d6",
          //   cancelButtonColor: "#d33",
          //   confirmButtonText: this.$t("confirm"),
          //   cancelButtonText: this.$t("cancel"),
          //   reverseButtons: false,
          // })
            title: this.$t("confirmDeletion"),
            html: this.$t("confirmDeletionTableName"),
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonText: this.$t("cancel"),
            confirmButtonText: `<span class="swal-delete-btn-content"><img src="${deleteIcon}" alt="" class="swal-delete-btn-icon" />${this.$t("delete")}</span>`,
            reverseButtons: false,
            focusCancel: true,
            buttonsStyling: false,
            customClass: {
              popup: "swal-delete-popup",
              title: "swal-delete-title",
              htmlContainer: "swal-delete-body",
              actions: "swal-delete-actions",
              confirmButton: "swal-delete-confirm",
              cancelButton: "swal-delete-cancel",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.DeleteSecurityGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      title: this.$t('_successfullyDeleted'),
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    this.Get();
                  }
                  this.dialog = false;
                },
                (err) => {
                  console.log(err);
                  this.dialog = false;
                }
              );
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    Get() {
      try {
        this.loadingTable = true;

        let { page, itemsPerPage, sortBy } = this.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: this.isSearch ? 1 : page,
          perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
          sortDesc: sortOrder,
          sortBy: sortField,
          name: this.searchDataIntegrationName,
        };
        this.$call.GetTableSecurityGroup(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dataTable = dataResponse.data.data;
              this.searchTotalTable = dataResponse.data.total;
              this.totalTable = this.isFirst
                ? dataResponse.data.total
                : this.totalTable;
            } else {
              this.dataTable = [];
              this.searchTotalTable = 0;
              this.totalTable = 0;
            }
            this.loadingTable = false;
            this.isFirst = false;
            this.isSearch = false;
          },
          (errorResource) => {
            this.loadingTable = false;
            this.isSearch = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
      }
    },

    async GetModel() {
      await this.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModel = dataResponse.data;
          } else {
            this.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Search() {
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchDataIntegrationName = null;
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },
    GetGroupModel() {
      this.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDGroupModel = dataResponse.data;
          } else {
            this.listDDGroupModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    Edit(item) {
      this.$router.push({
        name: "UserGroupDetail",
        query: {
          id: item.id,
        },
      });
    },
    GetDDModelQuickGroup() {
      this.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDQuickModel = dataResponse.data;
          } else {
            this.DDQuickModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>

<!-- Redesign Style -->
<style scoped>
.main-content-card {
  border-radius: 16px !important;
  border: 1px solid #DCDCDC !important;
  background: #FFF !important;
  overflow: hidden;
}
.group_user-management-container {
  padding: 24px;
}
.group_user-management-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}
.close-action-btn {
  border-radius: 16px;
  border: 1px solid linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  padding: 0 24px !important;
  height: 44px !important;
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
}
.close-action-btn:hover {
  transform: translateY(-1px);
  background: var(--tab-gradient-bg, linear-gradient(90deg, #F36243 0%, #FF8E7A 100%));
}
.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}
.tooltip-content {
  text-align: left;
  line-height: 1.5;
}

.tooltip-content div {
  margin-bottom: 2px;
}

.tooltip-content div:last-child {
  margin-bottom: 0;
}
.input-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #171717;
  line-height: 1.2;
}

.basic-info-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.border-section-wrapper {
  border-radius: 24px;
  padding: 15px 20px;
  border: 1px solid #CCCCCC;
  transition: all 0.3s ease;
}

.model-group-chip {
  border: 1px solid rgba(0, 23, 99, 0.25);
  background: rgba(56, 89, 208, 0.16);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.model-group-chip__label {
  background: linear-gradient(134deg, #3859D0 1.5%, #BD6AD5 127.43%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}

.model-display-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.model-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}

.model-display-chip {
  font-weight: 600;
  letter-spacing: 0.02em;
  background: #FFF !important;
  background-color: #FFF !important;
  color: #171717 !important;
  border: 1px solid #171717 !important;
}

.model-display-actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.model-display-more-btn {
  min-width: 36px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #646464 !important;
  color: #ffffff !important;
  font-weight: 600;
}

.model-display-more-btn:hover {
  background: #646464 !important;
}

.model-display-more-label {
  font-size: 0.85rem;
  line-height: 1;
}

.user-group-table {
  padding: 0px 20px;
  overflow: hidden;
}

.user-group-table :deep(thead) {
  background-color: #FFF2F2 !important;
}

.user-group-table :deep(thead tr) {
  background-color: #FFF2F2 !important;
}

.user-group-table :deep(thead th) {
  background-color: #FFF2F2 !important;
  color: #171717 !important;
  font-size: 16px !important;
  letter-spacing: 0.5px;
}
.user-group-table :deep(thead th span){
  font-weight: 600 !important;
}

.user-group-table :deep(thead th:first-child) {
  border-top-left-radius: 16px !important;
}

.user-group-table :deep(thead th:last-child) {
  border-top-right-radius: 16px !important;
}

.user-group-table :deep(.v-data-table__th) {
  background-color: #FFF2F2 !important;
  color: #171717 !important;
  font-weight: 800 !important;
}
.v-table :deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1 !important;
}

.template-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.template-dialog-icon {
  width: 25px;
  height: 25px;
}
</style>

<style scoped>
/* Base Styles */
.title {
  color: white;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Dialog Base Styles */
/* .modern-dialog, */
.detail-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 85vh;
}

.dialog-title {
  color: black;
}

.dialog-subtitle {
  color: gray;
}


/* .close-btn, */
.detail-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

/* .close-btn:hover, */
.detail-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

.count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #767676 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

/* Dialog Content */
.dialog-content {
  padding: 20px 24px !important;
  max-height: 60vh;
  overflow-y: auto;
}

.detail-content {
  padding: 0 !important;
  background: #fafafa;
  max-height: 50vh;
  overflow-y: auto;
}

.models-container {
  padding: 20px;
}

/* Form Sections */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
}

.section-content {
  margin-top: 5px;
}

.section-divider {
  margin: 24px 0;
  border-color: rgba(102, 126, 234, 0.2);
}

/* Form Fields */
.form-field {
  margin-bottom: 8px;
}

.modern-field {
  background: white;
  border-radius: 16px !important;
}

.modern-field :deep(.v-field) {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-field :deep(.v-field__input) {
  padding: 10px 16px !important;
  font-size: 0.95rem;
}

.modern-field :deep(.v-label) {
  font-weight: 500;
  color: #6c757d;
}

.modern-field :deep(.v-field--focused .v-label) {
  color: #171717 !important;
}

/* Icons and Chips */
.info-icon {
  transition: all 0.2s ease;
  opacity: 0.7;
}

.info-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

.model-chip {
  border: 1px solid #C30000 !important;
  color: #C30000 !important;
  background-color: #FFFFFF !important;
  border-radius: 999px !important;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin: 2px 4px 2px 0;
  padding: 0 8px !important;
}

.more-chip {
  color: #C30000 !important;
  border: 1px solid #C30000 !important;
  background-color: #FAEBEB !important;
  font-weight: 600;
}

.model-option-item {
  border-radius: 10px;
  transition: background 0.2s ease, border 0.2s ease;
}

:deep(.model-option-item--selected) {
  background: rgba(195, 0, 0, 0.08);
  border: 1px solid rgba(195, 0, 0, 0.25);
}

:deep(.model-option-checkbox) {
  margin-right: 8px;
}

:deep(.model-option-checkbox .v-selection-control__input) {
  width: 20px;
  height: 20px;
}

:deep(.model-option-title) {
  font-weight: 500;
}

:deep(.model-info-icon) {
  color: rgba(var(--v-theme-on-surface), 0.6);
  cursor: pointer;
  transition: color 0.2s ease;
}

:deep(.model-info-icon:hover) {
  color: #C30000;
}

.model-all-selected-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #C30000;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: #FAEBEB;
  white-space: nowrap;
  flex-shrink: 0;
}

.model-all-divider {
  width: 100% !important;
  border-color: #CCCCCC !important;
  height: 2px !important;
  opacity: 1 !important;
}

:deep(.model-all-option) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 14px !important;
  border-radius: 12px !important;
  cursor: pointer !important;
  transition: background 0.2s ease, border 0.2s ease, box-shadow 0.2s ease !important;
  width: 100% !important;
}

:deep(.model-all-option .v-list-item__content) {
  display: flex !important;
  align-items: center !important;
}

:deep(.model-all-title) {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
}

:deep(.model-all-option--active) {
  background: rgba(195, 0, 0, 0.08);
  border: 1px solid rgba(195, 0, 0, 0.3);
  box-shadow: 0 2px 8px rgba(195, 0, 0, 0.12);
}

:deep(.model-all-option--disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}

:deep(.model-all-option__label) {
  white-space: nowrap !important;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
}

.role-autocomplete :deep(.v-chip) {
  border: 1px solid #C30000 !important;
  color: #C30000 !important;
  border-radius: 999px !important;
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0 4px 0 12px !important;
}

.role-autocomplete :deep(.v-chip .v-chip__content) {
  color: #C30000 !important;
}

.role-autocomplete :deep(.v-chip .v-chip__close) {
  display: flex;
  align-items: center;
  padding: 0px 8px 0px 4px;
  border-left: 1px solid #646464;
  color: #646464 !important;
  opacity: 0.6;
  font-size: 14px !important;
  width: auto !important;
  height: 100%;
}

.role-autocomplete :deep(.v-chip .v-chip__close:hover) {
  opacity: 1;
}

.role-autocomplete :deep(.v-chip .v-chip__close .v-icon) {
  font-size: 14px !important;
}

.model-autocomplete :deep(.v-autocomplete__selection) {
  max-width: 100%;
  overflow: visible;
}

.model-autocomplete :deep(.v-autocomplete__selection:empty) {
  display: none !important;
}

.status-chip {
  font-weight: 500;
  letter-spacing: 0.025em;
}

.summary-chip {
  font-weight: 500;
  letter-spacing: 0.025em;
  border-radius: 40px;
  background: #EBEEFA !important;
  color: #3859D0 !important;
}

/* Selection Info */
.selection-info {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(76, 175, 80, 0.05);
  border: 1px solid rgba(76, 175, 80, 0.2);
  border-radius: 8px;
  margin-top: 8px;
}

.info-text {
  font-size: 0.9rem;
  color: #388e3c;
  font-weight: 500;
}

/* Dialog Actions */
.dialog-actions,
.detail-actions {
  padding: 10px 20px !important;
  background: white;
  border-top: 1px solid #e9ecef;
}

.actions-content,
.detail-actions-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.actions-content-new{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

/* Buttons */
.dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
}

.detail-action-btn {
  height: 40px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 100px;
}

.cancel-btn {
  border-radius: 16px;
  border: 1px solid #949AA8 !important;
  color: #646464 !important;
  font-weight: 600;
  text-transform: none;
  padding: 0 24px !important;
  height: 44px !important;
}

.cancel-btn:hover {
  transform: translateY(-1px);
}

.save-btn {
  /* Primary button */
  color: white !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.save-btn:disabled {
  background: linear-gradient(135deg, #e5a599 0%, #fbc4bb 100%) !important;
  color: #474747 !important;
  box-shadow: none !important;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

/* Model List and Cards */
.model-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.model-item {
  position: relative;
}

.model-card {
  border: 1px solid #C9C9C9;
  background: white;
  border-radius: 16px;
  padding: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.model-card:hover {
  border-color: rgba(195, 46, 14, 0.10);
  box-shadow: 0 8px 25px rgba(195, 46, 14, 0.10);
  transform: translateY(-2px);
}

.model-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.model-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.model-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid rgba(195, 46, 14, 0.25);
  background: rgba(195, 46, 14, 0.10);
}

.model-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.model-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.model-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: center;
}

.view-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 36px;
  white-space: nowrap;
}

.view-btn:hover {
  color: #C32E0E !important;
  border-color: #C32E0E !important;
  border-radius: 12px;
  background: #F9EAE7;
  transform: scale(1.05);
}

.model-divider {
  margin: 10px 0;
  border-color: rgba(74, 144, 226, 0.9);
}

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar,
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track,
.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb,
.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover,
.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {

  /* .modern-dialog, */
  .detail-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .model-card {
    animation: modelCardFadeIn 0.3s ease forwards;
  }

  @keyframes modelCardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

/* Focus States */
.view-btn:focus,
.detail-close-btn:focus,
.detail-action-btn:focus {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 960px) {

  /* .modern-dialog, */
  .detail-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .dialog-header,
  .detail-header {
    padding: 20px !important;
  }

  .detail-title {
    font-size: 1.2rem;
  }

  /* .dialog-subtitle, */
  .detail-subtitle {
    font-size: 0.8rem;
  }

  .dialog-content {
    padding: 24px 20px !important;
  }

  .models-container {
    padding: 20px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .actions-content,
  .detail-actions-content {
    flex-direction: column-reverse;
    gap: 12px;
    align-items: stretch;
  }

  .actions-right {
    justify-content: center;
  }

  .dialog-action-btn,
  .detail-action-btn {
    width: 100%;
  }

  .detail-header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .header-right {
    align-self: flex-end;
    width: 100%;
    justify-content: space-between;
  }

  .model-card {
    padding: 16px;
  }

  .model-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .model-info {
    width: 100%;
    justify-content: flex-start;
  }

  .model-actions {
    width: 100%;
    justify-content: center;
  }

  .view-btn {
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 600px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .header-right {
    align-self: flex-end;
  }

  .section-title {
    font-size: 1rem;
  }

  .modern-field :deep(.v-field__input) {
    padding: 14px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .model-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .model-name {
    font-size: 1rem;
  }

  .view-btn {
    height: 32px;
    font-size: 0.85rem;
  }

  .detail-action-btn {
    height: 36px;
    font-size: 0.9rem;
  }
}

/* Dark Theme Support */
/* .modern-dialog, */
.v-theme--dark .v-theme--dark .detail-dialog {
  background: #2d2d2d;
}

.v-theme--dark .dialog-content {
  background: #1e1e1e;
}

.v-theme--dark .detail-content {
  background: #1e1e1e;
}

.v-theme--dark .dialog-actions,
.v-theme--dark .detail-actions {
  background: #2d2d2d;
  border-top-color: #404040;
}

.v-theme--dark .models-container {
  background: #1e1e1e;
}

.v-theme--dark .modern-field {
  background: #2d2d2d;
}

.v-theme--dark .modern-field :deep(.v-field) {
  border-color: #404040;
}

.v-theme--dark .modern-field:focus-within :deep(.v-field) {
  border-color: #8a9cff !important;
}

.v-theme--dark .section-header {
  border-bottom-color: rgba(138, 156, 255, 0.2);
}

.v-theme--dark .section-divider {
  border-color: rgba(138, 156, 255, 0.2);
}

.v-theme--dark .section-title {
  color: #e0e0e0;
}

.v-theme--dark .selection-info {
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}

.v-theme--dark .info-text {
  color: #81c784;
}

.v-theme--dark .model-card {
  background: #2d2d2d;
  border-color: #404040;
}

.v-theme--dark .model-card:hover {
  border-color: rgba(100, 181, 246, 0.3);
  box-shadow: 0 8px 25px rgba(100, 181, 246, 0.2);
}

.v-theme--dark .model-icon-wrapper {
  background: rgba(100, 181, 246, 0.1);
  border-color: rgba(100, 181, 246, 0.3);
}

.v-theme--dark .model-name {
  color: #e0e0e0;
}

.v-theme--dark .model-divider {
  border-color: rgba(100, 181, 246, 0.2);
}

.v-theme--dark .empty-state {
  color: #bbb;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-track,
.v-theme--dark .detail-content::-webkit-scrollbar-track {
  background: #404040;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-thumb,
.v-theme--dark .detail-content::-webkit-scrollbar-thumb {
  background: #666;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-thumb:hover,
.v-theme--dark .detail-content::-webkit-scrollbar-thumb:hover {
  background: #777;
}
</style>
